Namespace 'Common.Sessions'

class Common.Sessions.SessionView extends Backbone.View
  id: 'sessions-container'

  initialize: ({session, sessions, getFiltersData, filtersFactory, chartListItemCollectionViewFactory}) ->
    @session = session
    @sessions = sessions
    @filtersFactory = filtersFactory
    @chartListItemCollectionViewFactory = chartListItemCollectionViewFactory
    @

  render: =>
    @currentSessionView.remove() if @currentSessionView
    @$el.append(@sessionView().render().el)
    @

  sessionView: ->
    if @session.isNew() then @emptySession() else @newSession()

  emptySession: ->
    @currentSessionView = new Common.Sessions.EmptySessionView(session: @session, sessions: @sessions)

  newSession: ->
    @currentSessionView = new Common.Sessions.NewSessionView
      session: @session
      filtersFactory: @filtersFactory
      chartListItemCollectionViewFactory: @chartListItemCollectionViewFactory

  shouldRerender: =>
    !@currentSessionView or @currentSessionView.shouldRerender()
